import { render, staticRenderFns } from "./PasswordView.vue?vue&type=template&id=08af7859&scoped=true"
import script from "./PasswordView.vue?vue&type=script&lang=js"
export * from "./PasswordView.vue?vue&type=script&lang=js"
import style0 from "./PasswordView.vue?vue&type=style&index=0&id=08af7859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af7859",
  null
  
)

export default component.exports